/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var BundleSummary;
(function (BundleSummary) {
    /**
     * Offset type classification
     *
     */
    let offset_type;
    (function (offset_type) {
        offset_type["EMISSIONS_REDUCTION"] = "emissions_reduction";
        offset_type["CARBON_REMOVAL"] = "carbon_removal";
    })(offset_type = BundleSummary.offset_type || (BundleSummary.offset_type = {}));
    /**
     * The bundle's carbon storage permanence.
     */
    let carbon_permanence;
    (function (carbon_permanence) {
        carbon_permanence["LONG_TERM"] = "long_term";
        carbon_permanence["SHORT_TERM"] = "short_term";
    })(carbon_permanence = BundleSummary.carbon_permanence || (BundleSummary.carbon_permanence = {}));
})(BundleSummary || (BundleSummary = {}));
//# sourceMappingURL=BundleSummary.js.map